/**
 * Per-stage enemy personality assignment.
 *
 * Each enemy slot is assigned a personality (see types.ts) at create-time via
 * `personalityForEnemy(stage, idx)`. The palette widens with stage: early
 * stages mix one interceptor with chasers/wanderers; late stages drop pure
 * chasers entirely in favor of interceptors and anticipators.
 *
 * Pure data: no AI logic, no maze access. Lookup only.
 */

import type { EnemyPersonality } from './types.ts';

// AIDEV-NOTE: palette length can exceed enemy count at low stages — extra
// entries are intentionally "tail" personalities (chaser, wanderer) that only
// appear when stage headcount grows. By stage 5+, no pure chasers remain.
export function paletteForStage(stage: number): EnemyPersonality[] {
  if (stage <= 1) return ['interceptor', 'chaser'];
  if (stage <= 2) return ['interceptor', 'wanderer', 'chaser'];
  if (stage <= 4) return ['interceptor', 'anticipator', 'wanderer', 'chaser'];
  return ['interceptor', 'anticipator', 'interceptor', 'wanderer', 'anticipator'];
}

export function personalityForEnemy(stage: number, idx: number): EnemyPersonality {
  const palette = paletteForStage(stage);
  return palette[idx % palette.length]!;
}
